export const getMediaDisplay = ({ prefs, imagesToDisplay, deviceType }) => {
	const threeUpRatio = parseFloat(prefs.threeUpRatio) || 1;
	const responsiveDesktopImage = prefs.responsiveDesktopImage !== 'false';

	const isMobile = deviceType === 'MOBILE';
	const isDesktop = deviceType === 'DESKTOP';
	const responsiveImage = isMobile || responsiveDesktopImage;
	const numSlides = imagesToDisplay.length;
	const threeUpDisplay = threeUpRatio < 3 && numSlides > 1 && isDesktop;
	const imageMode = !responsiveImage || threeUpDisplay || isMobile; // Always use <Image> elements on mobile

	return { threeUpDisplay, imageMode, responsiveImage, numSlides };
};
